export const SCREEN_SIZES = ["xs", "sm", "md", "lg", "xl"]

export const STYLE_PROPS = {
    SPACE: {
        PADDING: ["p", "px", "py", "pl", "pt", "pr", "pb"],
        MARGIN: ["m", "mx", "my", "ml", "mt", "mr", "mb", { propName: "between", className: "sb" }],
    },
    COLOR: ["color", "bg"],
    TEXT: [
        { propName: "lineHeight", className: "line-height" },
        { propName: "fontWeight", className: "font-weight" },
        { propName: "fontSize", className: "font-size" },
        { propName: "decoration", className: "t-decor" },
        { propName: "nowrap", className: "text-nowrap" },
        { propName: "textTransform", className: "t-trans" },
        { propName: "textAlign", className: "t-align" },
    ],
    COLUMNS: ["columns"],
    DISPLAY: [{ propName: "display", className: "d" }],
    BORDER: [
        { propName: "border", className: "b" },
        { propName: "borderRight", className: "br" },
        { propName: "borderLeft", className: "bl" },
        { propName: "borderTop", className: "bt" },
        { propName: "borderBottom", className: "bl" },
    ],
    WIDTH: ["w"],
}

export function createPropsToClassNamesMapper(allowedProps) {
    return (componentProps) => {
        const classNames = []
        for (const prop of allowedProps) {
            const propName = typeof prop === "string" ? prop : prop.propName
            const className = typeof prop === "string" ? prop : prop.className
            if (!(propName in componentProps)) {
                continue
            }

            if (
                typeof componentProps[propName] === "string" ||
                typeof componentProps[propName] === "number"
            ) {
                classNames.push(`${className}-${componentProps[propName]}`)
            }

            if (typeof componentProps[propName] === "boolean") {
                classNames.push(className)
            }

            if (typeof componentProps[propName] === "object" && componentProps[propName] !== null) {
                for (const [screenSize, value] of Object.entries(componentProps[propName])) {
                    if (screenSize === "xs") {
                        // xs ~ empty screen size in bootstrap
                        classNames.push(`${className}-${value}`)
                        continue
                    }

                    if (!SCREEN_SIZES.includes(screenSize)) {
                        continue
                    }

                    classNames.push(`${className}-${screenSize}-${value}`)
                }
            }
        }

        return classNames.join(" ")
    }
}
